import React, { Component } from "react";
import { connect } from "react-redux";
import { themeToggle } from "../redux/actions/theme.action";
// import Moon from "../assets/imgs/moon.png";
// import Sun from "../assets/imgs/sun.png";
class ThemeToggler extends Component {
  state = {};
  render() {
    return (
      <>
        {/* <div className='d-flex align-items-center'>
					<img src={Sun} width='30' className='ml-1' />
					<label for='theme' className='switch'>
						<input
							type='checkbox'
							id='theme'
							onChange={e => {
								this.props.themeToggle(e.target.checked);
							}}
							defaultChecked={this.props.themeType == 'dark'}
						></input>
						<div className='slider round'></div>
					</label>
					<img src={Moon} width='30' className='mr-1' />
				</div>
			 */}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    themeType: state.theme.themeType,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    themeToggle: (type) => dispatch(themeToggle(type)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ThemeToggler);
